module.exports = __webpack_public_path__ + "static/media/top2.a3758abe.svg";